import { Dispatch, SetStateAction } from 'react';

import { CreateSpeaker, Speaker } from '@/types/speakers.types';
import { updateTranslateKey } from '@/utils/update-translation-key';
import GlobalContainer from '@ui/container/global-container';
import Text from '@ui/text/text/text';

type TEditBioProps = {
  workingSpeaker: Speaker | CreateSpeaker;
  setWorkingSpeaker: Dispatch<SetStateAction<Speaker | CreateSpeaker>>;
  baseLanguage: string;
  language: string;
};

const EditBio = ({ baseLanguage, language, workingSpeaker, setWorkingSpeaker }: TEditBioProps) => {
  return (
    <label htmlFor="bio" className="flex-column gap-4">
      <Text design="GlobalIcoText3" className="P2 margin-l-16">
        Bio
      </Text>
      <GlobalContainer<'textarea'>
        id="email"
        rows={4}
        TagName="textarea"
        value={workingSpeaker?.description?.base || ''}
        onChange={(e) =>
          setWorkingSpeaker((prev) => ({
            ...prev,
            description: updateTranslateKey({
              translateString: workingSpeaker.description ?? { base: '', changed: '' },
              input: e.target.value,
              baseLanguage,
              language,
            }),
          }))
        }
        css="background-color: transparent; width: 100%; padding: 10px 16px; outline: none; border: 1px solid var(--global-ico-text-3); border-radius: 16px;"
        className="P2 clear-textarea"
        mode="GlobalIcoText1"
        placeholder="Add bio"
      />
    </label>
  );
};

export default EditBio;
